import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { EventsService } from 'src/app/services/events.service';

@Component({
  selector: 'app-qr-scaner',
  templateUrl: './qr-scaner.component.html',
  styleUrls: ['./qr-scaner.component.scss']
})
export class QrScanerComponent implements OnInit {

  // @ViewChild('scanner', {static: true})scanner: ZXingScannerComponent;
  @Input('hasCameras') hasCameras = false;
  hasPermission: boolean;
  qrResultString: string;

  availableDevices: MediaDeviceInfo[];
  selectedDevice: MediaDeviceInfo;

  constructor(
    private eventsService: EventsService,
  ) { 
    this.selectedDevice = null;
  }

  ngOnInit(): void {

  }

  handleQrCodeResult(resultString: string) {
      this.qrResultString = resultString;
      this.eventsService.scanQrSuccess.emit(this.qrResultString);
  }

}
